import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import DashboardShell from "@/components/DashboardShell";
import ReportView from "@/components/ReportView";
import { ReportNotes } from "@/components/report/ReportNotes";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Link2, Users, LayoutDashboard, PlayCircle, Mail, FileBadge } from "lucide-react";

const LINKS = [
  { to: "/me", label: "Dashboard", icon: LayoutDashboard, testId: "nav-me-dashboard" },
  { to: "/me/students", label: "My Students", icon: Users, testId: "nav-me-students" },
  { to: "/me/link", label: "My Link", icon: Link2, testId: "nav-me-link" },
  { to: "/me/inbox", label: "Inbox", icon: Mail, testId: "nav-me-inbox" },
  { to: "/me/sample-report", label: "Sample Report", icon: FileBadge, testId: "nav-me-sample-report" },
  { to: "/me/demo", label: "Launch Demo", icon: PlayCircle, testId: "nav-me-demo" },
];

export default function MarketingStudentReport() {
  const { studentId } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/marketing/students/${studentId}/report`).then((res) => setReport(res.data)).catch((e) => {
      setError(e?.response?.data?.detail || "Report not available");
    });
  }, [studentId]);

  return (
    <DashboardShell links={LINKS} activePath="/me/students">
      <Button variant="ghost" data-testid="me-report-back-button" onClick={() => navigate("/me/students")} className="text-slate-500 mb-6">
        <ArrowLeft className="h-4 w-4 mr-2" /> Back to My Students
      </Button>
      {error && <p className="text-slate-400" data-testid="me-report-error">{error}</p>}
      {report && (
        <div className="space-y-6">
          <ReportView report={report} isDemo={false} translateUrl={`/marketing/students/${studentId}/report/translate`} />
          <ReportNotes notesUrl={`/marketing/students/${studentId}/notes`} />
        </div>
      )}
    </DashboardShell>
  );
}
